/**
 * Welcome Section Component
 * Figma: Welcome (Node: 479:19743)
 *
 * Centered welcome heading and intro paragraph
 * Dimensions: 720px wide, 109px tall
 * Padding: generous top spacing with slightly tighter bottom spacing so the
 * editorial lane tabs remain visible on desktop.
 */
"use client";

import { SECTION_PADDING_Y } from "@/styles/responsive-spacing";

export function WelcomeSection() {
  return (
    <section
      className="flex w-full justify-center"
      style={{
        paddingTop: SECTION_PADDING_Y.SMALL,
        paddingBottom: SECTION_PADDING_Y.XSMALL,
      }}
    >
      <div
        className="flex w-full flex-col items-center"
        style={{
          maxWidth: "720px",
          gap: "40px",
          paddingLeft: "clamp(16px, 4vw, 40px)",
          paddingRight: "clamp(16px, 4vw, 40px)",
        }}
      >
        <p className="text-overline-wide text-ink-faint text-center">Welcome</p>

        <p className="text-body-lg text-ink text-center">
          From the exact piece you want to the detail you didn&apos;t know to ask for: welcome to
          the Cosimo universe. Shop with intelligence — explore over 10,000 brands by designer, by
          detail, or by inspiration.
        </p>
      </div>
    </section>
  );
}
